import { Response } from 'shared/models/general.ts'

import { clientApi } from '../clientApi'

import { ICheckPay } from './model'

export const CheckPayment = {
  checkPaymentRequest(orderId: string) {
    return clientApi.get<Response<ICheckPay>>(
      `/flights/tickets/status/${orderId}/1/`,
    )
  },
  checkPaymentRequestByCertificate(orderId: string) {
    return clientApi.get<Response<ICheckPay>>(
      `/flights/tickets/status/${orderId}/9/`,
    )
  },
}
